import { makeFailure, makeSuccess, TResult, loadFileUrlToBase64data } from "@sg-core/index";

export interface IEmailAttachment {
    filename: string;
    base64data: string;
};

export interface IEmailAttachmentDTO {
    nimi: string;
    base64sisalto: string;
};

export type TEmailAttachments = Array<IEmailAttachment>;

export type TEmailAttachmentsDTO = Array<IEmailAttachmentDTO>;


export const EmailAttachmentMapper = {
    attachmentToApi: (domain: IEmailAttachment): IEmailAttachmentDTO => {
        return {
            nimi: domain.filename,
            base64sisalto: domain.base64data
        }
    },
    attachmentsToApi: (domain: TEmailAttachments): TEmailAttachmentsDTO => {
        return domain.map(EmailAttachmentMapper.attachmentToApi);
    },
    fileUrlToAttachment: async (href: string, filename: string): Promise<TResult<IEmailAttachment>> => {
        const data = await loadFileUrlToBase64data(href);
        if (!data.isSuccess) {
            return makeFailure(data.error);
        };
        const attachemnt: IEmailAttachment = {
            filename: filename,
            base64data: data.value
        };
        return makeSuccess(attachemnt);
    }
};

